export default {
  computed: {
    interfaceKeyPrefix() {
      const prefixes = [
        { findField: "Solicitor", addressPrefix: "SolicitorAddress" },
        { findField: "Correspondence", addressPrefix: "Correspondence" },
        { findField: "FindProperty", addressPrefix: "InsuredAddress" },
      ];
      for (const p of prefixes) {
        if (this.question.InterfaceKey.startsWith(p.findField))
          return p.addressPrefix;
      }
      return "InsuredAddress";
    },
  },
};
